import { Button } from "@landtechnologies/components";
import { useTranslation } from "react-migration/lib";
import { BillingWrapper } from "react-migration/domains/billing";

export const CurrentPlan = () => {
  const { t } = useTranslation();

  return (
    <div className="atlas-mb-6">
      <div>
        If you need invoices from before 2024 please email{" "}
        <a href="mailto:support@land.tech">accounts@land.tech</a> requesting the invoices you need
      </div>
      <br />
      <BillingWrapper>
        <Button.Secondary>{t("dashboard.your_account_balance.view_invoices")}</Button.Secondary>
      </BillingWrapper>
    </div>
  );
};
